import * as yup from 'yup'
import * as linkSchemas from '../link/Link.schema'
import { createDataRef, createWeakDataRef, createDataSchema } from '../schemaUtils'
import { vectorImageDataSchema } from '../VectorImage/VectorImage.schema'

const menuBaseTypes = {
	id: yup.string(),
	link: createDataRef(linkSchemas).nullable(),
	label: yup.string(),
	slot: yup.string(),
	isVisible: yup.bool().default(true),
	isVisibleMobile: yup.bool().default(true),
	displayCount: yup.number().nullable(),
	iconRef: createDataRef({ VectorImage: vectorImageDataSchema }).nullable(),
}

export const subItemDataSchema = createDataSchema('BasicMenuItem', yup.object(menuBaseTypes))

export const basicMenuItem = createDataSchema(
	'BasicMenuItem',
	yup.object({
		...menuBaseTypes,
		items: yup
			.array(createDataRef({ BasicMenuItem: subItemDataSchema }))
			.nullable()
			.default([]),
	})
)

export const customMenu = createDataSchema(
	'CustomMenu',
	yup.object({
		name: yup.string(),
		items: yup
			.array(createDataRef({ BasicMenuItem: basicMenuItem }))
			.nullable()
			.default([]),
	})
)

export const customMenuDataRef = createDataSchema(
	'CustomMenuDataRef',
	yup.object({
		menuRef: createWeakDataRef('CustomMenu').nullable(),
	})
)
